module.exports = __webpack_public_path__ + "static/media/sidebar-button-highlighted.31614f08.png";